import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GuestFeedbackThemeSummaryQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.GuestFeedbackThemeSummaryInput>;
}>;


export type GuestFeedbackThemeSummaryQuery = { __typename?: 'Query', GuestFeedbackThemeSummary: Array<{ __typename?: 'GuestFeedbackTheme', id: string, name: string, mentionCount?: number | null }> };


export const GuestFeedbackThemeSummaryDocument = gql`
    query GuestFeedbackThemeSummary($input: GuestFeedbackThemeSummaryInput) {
  GuestFeedbackThemeSummary(input: $input) {
    id
    name
    mentionCount
  }
}
    `;

/**
 * __useGuestFeedbackThemeSummaryQuery__
 *
 * To run a query within a React component, call `useGuestFeedbackThemeSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestFeedbackThemeSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestFeedbackThemeSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGuestFeedbackThemeSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GuestFeedbackThemeSummaryQuery, GuestFeedbackThemeSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestFeedbackThemeSummaryQuery, GuestFeedbackThemeSummaryQueryVariables>(GuestFeedbackThemeSummaryDocument, options);
      }
export function useGuestFeedbackThemeSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestFeedbackThemeSummaryQuery, GuestFeedbackThemeSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestFeedbackThemeSummaryQuery, GuestFeedbackThemeSummaryQueryVariables>(GuestFeedbackThemeSummaryDocument, options);
        }
export type GuestFeedbackThemeSummaryQueryHookResult = ReturnType<typeof useGuestFeedbackThemeSummaryQuery>;
export type GuestFeedbackThemeSummaryLazyQueryHookResult = ReturnType<typeof useGuestFeedbackThemeSummaryLazyQuery>;
export type GuestFeedbackThemeSummaryQueryResult = Apollo.QueryResult<GuestFeedbackThemeSummaryQuery, GuestFeedbackThemeSummaryQueryVariables>;